import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Box, Paper, Link } from '@mui/material';
import axios from 'axios';
import logo from '../assets/logo.jpg';
import '../index.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const API_URL = process.env.REACT_APP_API_URL;

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        
        if (email === '') {
            setError('Por favor, introduce tu correo electrónico');
            return;
        }

        try {
            const response = await axios.post(`${API_URL}/api/forgot-password`, { email });
            setMessage(response.data.message);
        } catch (error) {
            setError(error.response?.data?.message || 'Error al enviar la solicitud');
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Paper elevation={3} sx={{ padding: 4, borderRadius: 2, backgroundColor: '#f6f8e4' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img src={logo} alt="Logo del Consultorio" style={{ width: 100, marginBottom: 20 }} />
                    <Typography component="h1" variant="h5">Recuperar Contraseña</Typography>
                    <form onSubmit={handleForgotPassword} style={{ width: '100%', marginTop: 1 }}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Correo Electrónico"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {error && (
                            <Typography color="error" variant="body2">
                                {error}
                            </Typography>
                        )}
                        {message && (
                            <Typography color="primary" variant="body2">
                                {message}
                            </Typography>
                        )}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ marginTop: 3, marginBottom: 2 }}
                        >
                            Enviar
                        </Button>
                    </form>
                    <Link href="/login" variant="body2" sx={{ marginTop: 2 }}>
                        ¿Recordaste tu contraseña? Iniciar Sesión
                    </Link>
                </Box>
            </Paper>
        </Container>
    );
};

export default ForgotPassword;
